import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@website/ui/skeleton";
import { FC } from "react";
type AccommodationCardSkeletonProperties = {
  className?: string;
};
export const AccommodationCardSkeleton: FC<AccommodationCardSkeletonProperties> = t0 => {
  const $ = _c(7);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `flex h-auto w-full flex-col overflow-hidden rounded-xl ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-[212px] shrink-0"><Skeleton className="!rounded-2xl" /></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-3 h-[54px] shrink-0"><Skeleton className="!rounded-2xl" /></div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-1 h-9 w-[45%] max-w-[129px] shrink-0"><Skeleton className="!rounded-2xl" /></div>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-[5px] h-[36px] w-[58%] max-w-[166px] shrink-0"><Skeleton className="!rounded-2xl" /></div>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mt-3 h-12 shrink-0 md:hidden"><Skeleton className="!rounded-lg" /></div>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t2) {
    t8 = <div aria-hidden="true" className={t2}>{t3}{t4}{t5}{t6}{t7}</div>;
    $[5] = t2;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};